import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

const Title = styled(Typography)({
  color: 'white',
  fontSize: '56px',
  fontFamily: 'Montserrat',
  fontWeight: 500,
  lineHeight: '56px',
  wordWrap: 'break-word',
});

export default Title;
